import { lazy } from 'react';
import { Route } from 'react-router-dom';
import EnvConfig from '../configs/envConfig/envConfig';
import { ProtectedLayout } from '../features/layout/ProtectedLayout/ProtectedLayout';
import { RoleTypeEnum } from '../uc-api-sdk';

// Lazy loaded components
const PlaygroundComponent = lazy(() => import('../features/playground/PlaygroundComponent'));
const ArticlesPageLayout = lazy(() => import('../sample/component/ArticlesPageLayout'));
const MainArticleHookUsageSampleComponent = lazy(() => import('../sample/component/ArticleHookUsageSampleComponent/MainArticleHookUsageSampleComponent'));
const MainArticleWCacheSampleComponent = lazy(() => import('../sample/component/ArticleSampleWithCache/MainArticleWCacheSampleComponent'));
const MainArticleSimpleSampleComponent = lazy(() => import('../sample/component/ArticleSimpleSample/MainArticleSimpleSampleComponent'));
const MainArticleWNewFunctionSampleComponent = lazy(() => import('../sample/component/ArticleWNewFunction/MainArticleWNewFunctionSampleComponent'));
const MainComponentVsContainerComponent = lazy(() => import('../sample/component/ComponentVsContainerComponent/MainComponentVsContainerComponent'));
const MainInputComponentComponent = lazy(() => import('../sample/component/InputSampleComponent/MainInputSampleComponent'));
const MainSampleChangePageComponent = lazy(() => import('../sample/component/SampleChangePageComponent/MainSampleChangePageComponent'));
const MainSampleFormComponent = lazy(() => import('../sample/component/SampleFormComponent/MainSampleFormComponent'));
const MainTableSampleComponent = lazy(() => import('../sample/component/TableSampleComponent/MainTableSampleComponent'));
const VisibilitySampleComponent = lazy(() => import('../sample/component/VisibilitySampleComponent/VisibilitySampleComponent'));
const MainFormIterableHookSampleComponent = lazy(() => import('../sample/component/FormListSample/MainFormIterableHookSampleComponent'));
const ReassignPatientsPageComponent = lazy(() => import('../features/reassignPatients/component/ReassignPatientsPageComponent/ReassignPatientsPageComponent'));

export const createSampleRoutes = () => (
  <Route
    element={(
      EnvConfig.isDev
        ? null
        : <ProtectedLayout roleWhiteList={[RoleTypeEnum.SUPER_ADMIN]} />
    )}
  >
    <Route
      path="/playground"
      element={<PlaygroundComponent />}
    />
    <Route
      path="/internal-tool/reassign-patients"
      element={<ReassignPatientsPageComponent />}
    />
    <Route
      path="/sample"
      element={<ArticlesPageLayout />}
    />
    <Route
      index
      element={<MainArticleSimpleSampleComponent />}
    />
    <Route
      path="/sample/simple"
      element={<MainArticleSimpleSampleComponent />}
    />
    <Route
      path="/sample/new-function"
      element={<MainArticleWNewFunctionSampleComponent />}
    />
    <Route
      path="/sample/cache"
      element={<MainArticleWCacheSampleComponent />}
    />
    <Route
      path="/sample/request-hook"
      element={<MainArticleHookUsageSampleComponent />}
    />
    <Route
      path="/sample/visibility"
      element={<VisibilitySampleComponent />}
    />
    <Route
      path="/sample/Form"
      element={<MainSampleFormComponent />}
    />
    <Route
      path="/sample/change-page"
      element={<MainSampleChangePageComponent />}
    />
    <Route
      path="/sample/table"
      element={<MainTableSampleComponent />}
    />
    <Route
      path="/sample/input"
      element={<MainInputComponentComponent />}
    />
    <Route
      path="/sample/component-vs-container"
      element={<MainComponentVsContainerComponent />}
    />
    <Route
      path="/sample/iterableFormHook"
      element={<MainFormIterableHookSampleComponent />}
    />
  </Route>
);

export default createSampleRoutes;
